import { TApplicationState } from 'shared/mf-infrastructure/types/redux';

export const selectActiveTab = (state: TApplicationState) => state.transportAccessibility.activeTab;
